import React from "react";
import ModalWrap from "./ModalWrap";
import "./logoutconfirmation.scss";
import logoutAlert from "../../assets/images/logoutAlert.svg";
import { Typography } from "@mui/material";
import { logoOut } from "../../services/websiteApi";
import { getParams } from "../../utlis/helpers";
import { clearStoredSession } from "../mmtUserList/mmtFlow";
import { LOGIN } from "../../routes/routerPath";
import { useDispatch } from "react-redux";
import { setAPILoader } from "../../state/actions/globalAction";
import { useT } from "../../i18n/useT";
import { postWebViewMessage } from "../../utlis/webViewBridge";

const LogoutConfirmation = ({ logout, setlogout }) => {
  const { accessToken, locale } = getParams();
  const dispatch = useDispatch();
  const t = useT("popup");
  const logoutHandler = () => {
    dispatch(setAPILoader(true));
    logoOut({ globalSignOut: false, token: accessToken })
      .then(() => {
        clearStoredSession();
        sessionStorage.clear();
        // Notify the WebView shell (if any), then always land on the web
        // login screen — the web app owns the whole flow now.
        postWebViewMessage("LOGOUT");
        window.location.href = `${LOGIN}?locale=${locale || "en"}`;
        dispatch(setAPILoader(false));
        setlogout();
      })
      .catch(() => {
        dispatch(setAPILoader(false));
      });
  };
  return (
    <ModalWrap
      className="logout-confirm-wrapper"
      open={logout}
      onClose={() => setlogout()}
    >
      <div className="logout-content">
        <img src={logoutAlert} alt="logout" className="img" />
        <Typography className="text">{t("logout_confirmation")}</Typography>
        <button className="log-btn" onClick={() => logoutHandler()}>
          {t("logoutText")}
        </button>
        <button className="cancel-btn" onClick={() => setlogout()}>
          {t("cancel")}
        </button>
      </div>
    </ModalWrap>
  );
};

export default LogoutConfirmation;
